import { html } from 'lit-element';
import { translate } from '@forter/directives';
// TODO: release link
// import '@forter/link';

export const link = ({ cellData }) => html`
  <fc-link>${translate(cellData)}</fc-link>
`;
